// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Menu = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 22 16" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g
			stroke="#FFF"
			strokeWidth={2}
			fill="none"
			fillRule="evenodd"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M1 1h20M1 8h20M1 15h20" />
		</g>
	</svg>
);
export default Menu;
